function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m7.607 26.22.814-2.69-1.082-1.06C5.535 20.7 4.5 18.432 4.5 16c0-5.152 4.844-9.847 11.5-9.847S27.5 10.848 27.5 16c0 5.152-4.844 9.847-11.5 9.847-.668 0-1.32-.05-1.955-.142a12.874 12.874 0 0 1-2.39-.587l-.961-.338-3.087 1.44Zm-.971 3.212 4.191-1.955c.909.318 1.864.556 2.855.701.754.111 1.528.169 2.318.169 7.732 0 14-5.528 14-12.347S23.732 3.653 16 3.653 2 9.181 2 16c0 3.174 1.358 6.068 3.59 8.255l-1.476 4.88a.801.801 0 0 0 1.106.959l1.416-.662ZM22.1 17.8a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6ZM17.8 16a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0Zm-7.9 1.8a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z"
  }));
};
var componentName = 'ChatOutlined';
export var ChatOutlined = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
ChatOutlined.displayName = componentName;